import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import ChangeUserByProxyComponent from "../../../components/Customer/proxies/ChangeUserByProxyComponent";

const ChangeUserByProxyPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <ChangeUserByProxyComponent
        redirectBack={ () => redirectBack() }
        listId={ new URLSearchParams(search).get('listId') }
    />
}

export default ChangeUserByProxyPage;